import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRemove } from '@fortawesome/free-solid-svg-icons'
import createReactClass from 'create-react-class'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { ValidationBox, Input } from 'legacy/libs/react-form-tools'

import { GetText } from 'lib/gettext'

export default createReactClass({
  displayName: 'AlternativeNames',

  mixins: [SchemaBranchMixin],

  schema: {
    alternativeNames: [],
  },

  onAddClick() {
    this.cursors.alternativeNames.push('')
  },

  onRemoveClick(cursor) {
    cursor.unset()
  },

  renderAlternativeNameBlock(cursor, index) {
    return (
      <div className="relative" key={index}>
        <ValidationBox
          fieldPath={['alternativeNames', index]}
          className="validationbox"
        >
          <Input
            id={`id_create-${index}-name`}
            className="input"
            maxLength="140"
          />

          <FontAwesomeIcon
            icon={faRemove}
            className="absolute top-1/2 right-0 h-[18px] -translate-y-1/2 cursor-pointer p-3 text-black/25 transition-colors hover:text-black/50"
            onClick={this.onRemoveClick.bind(this, cursor)}
          />
        </ValidationBox>
      </div>
    )
  },

  render() {
    return (
      <>
        {this.state.alternativeNames.length > 0 && (
          <div>
            <label className="mb-2 block text-default-light">
              <GetText>Alternative name</GetText>
            </label>

            <div className="space-y-4" id="alternative-name-container">
              {this.cursors.alternativeNames.map(
                this.renderAlternativeNameBlock
              )}
            </div>
          </div>
        )}

        <button onClick={this.onAddClick} className="link" type="button">
          <GetText>Add alternative name</GetText>
        </button>
      </>
    )
  },
})
